<template>
    <div class="card" v-animate-css="'fadeInLeft'">
        <div class="card-header">
            <h3 class="card-title">
                <span v-if="!type.id"> Add </span>
                <span v-if="type.id"> Edit </span>
                Type
            </h3>
            <div class="card-tools">
                <div class="overlay" v-if="isLoading">
                    <i class="fas fa-sync-alt fa-spin fa-1x"></i>
                </div>

                <button class="btn btn-tool btn-sm" v-if="!isLoading" @click.prevent="clear()">
                    <i class="fa fa-plus"></i>
                </button>
            </div>
            <!-- /.card-tools -->
        </div>
        <!-- /.card-header -->
        <div class="card-body">
            <form role="form">
                <div class="row">
                    <div class="col-md-12">
                        <!-- text input -->
                        <div class="form-group">
                        <label>Name</label>
                        <input type="text" class="form-control" v-model="type.name">
                        </div>
                    </div>
            </div>
            <div class="row">
                <div class="col-md-5">
                    <div class="form-group">
                        <div class="btn-group btn-group-toggle">
                            <label class="btn btn-sm btn-default"  :class="{'text-green': type.status === 'active'}">
                                <input type="radio" value="active" v-model="type.status"> Active
                            </label>
                            <label class="btn btn-sm btn-default" :class="{'text-red': type.status === 'suspended'}">
                                <input type="radio" value="suspended" v-model="type.status"> Suspended
                            </label>
                            </div>
                        </div>
                </div>
                <div class="col-md-3">

                    <div class="custom-control custom-checkbox">
                        <input class="custom-control-input" type="checkbox" id="customCheckbox2"  v-model="type.system_default">
                        <label for="customCheckbox2" class="custom-control-label" data-toggle="tooltip" data-placement="top" 
                            title="System defualt will be available for network accounts to see">
                            System Default</label>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="form-group float-right">
                        <button class="btn btn-success" @click.prevent="submit()"> Save </button>
                    </div>
                </div>

                <div class="col-md-12">
                    <errors :errors="errors"/>
                    <messages :messages="messages" />
                </div>
            </div>

            </form>
        </div>
    <!-- /.card-body -->
    </div>
    <!-- /.card -->

</template>

<script>
import { RepositoryFactory } from '@/services/repositories/ManagementAPI/RepositoryFactory' 
const GroupsTypesRepo = RepositoryFactory.get('groups_types')

export default {
    props: {
        type: {
            required: true,
            type: Object
        },
        isLoading: {
            required: false,
            type: Boolean
        },
    },
    data() {
        return {
            messages: [],
            errors: []
        }
    },
    methods: {
        submit: function() {
            if(typeof this.type.id === 'undefined') {
                this.create(this.type)
            } else {
                this.update(this.type)
            }
        },
        clear: function() {
            this.errors = []
            this.messages = []

            this.type = {}
        },
        create: function(type) {
            this.errors = []
            this.messages = []

            GroupsTypesRepo.post(type).then(result => {
                if(typeof result.data.id !== 'undefined' ) 
                    this.type = result.data
                    this.messages.push("Successfully added with ID: " + result.data.id)
                    this.$emit('updateList', this.type)
            }).catch(err => {
                this.errors.push(err)
                this.errors.push( err.response.data )
            })
        },
        update: function(type) {
            this.errors = []
            this.messages = []

            GroupsTypesRepo.patch(this.type.id, type).then(result => {
                if(typeof result.data.id !== 'undefined' ) 
                    this.type = result.data
                    this.messages.push("Successfully updated.")
                    this.$emit('refreshList', true)
            }).catch(err => {
                this.errors.push(err)
                this.errors.push( err.response.data )
            })
        },
        delete: function(id) {
            this.errors = []
            this.messages = []

            GroupsTypesRepo.delete(id).then(result => {
                this.messages.push(result.data)
            }).catch(err => {
                this.errors.push(err)
                this.errors.push( err.response.data )
            })
        },
    },
}
</script>